var HBD = window.HBD || {};

/** track events via Google Analytics */
function hbdTrackEvent(cat, act, lab, val) {
	var eventObj = {
    	'Kategorie': cat,
        'Action': act,
        'event': 'genericEvent' 
	};
	
	if (lab && lab.length !== 0) {
        eventObj['Label'] = lab;
	}

	if (val && val.length !== 0) {
        eventObj['Wert'] = val;
	}
	
	dataLayer.push(eventObj);
}

function updateCompletionPie( val ){
	if (val >= 50){
        $(".pie-wrapper").addClass("pie-over50");
    }
    else {
        $(".pie-wrapper").removeClass("pie-over50");
    }
    if (val == 100){
        $(".pie-wrapper + p").html("Ihr Profil ist komplett ausgefüllt.");
    }
    else {
        $(".pie-wrapper + p").html("Ihr Profil weist noch Lücken auf.");
    }
	$(".pie-wrapper").find(".pie-text span").html(val + "%").end().find(".pie-spinner").attr("style", "transform:rotate("+ val / 100 + "turn)");
}


$(function() {
	/**
	 * IE/Safari hack for input[type="date"]
	 */
	if ($('#birthdate').length) {
		if ($('#birthdate')[0].type != 'date') $('#birthdate').attr("placeholder", "JJJJ-MM-TT");
	}

	$('.accordion').accordion();

 	// top user menu
 	var $userUl = $('#userInfos').find('ul').eq(0);
 	
	$('.loggedUser').on('click', function(ev) {
		ev.stopPropagation();
		$userUl.toggle();
	});

	$userUl.on('click', function(ev) {
		ev.stopPropagation();	
	});	

	$('html').click(function(e) {
		if ($userUl.is(':visible')) {
			$userUl.hide();
		}
	});

	/*old info-bubble for labels (not needed anymore in new design, kept here for partner-designs)*/
 	$('label[title]').addClass('info').powerTip({ placement: 'ne-alt' });
 	
 	// counter for textarea fields with maxlength attribute
	$('textarea[maxlength]').counter();
	
	$('div.helpBtn').addClass('info').powerTip({ placement: 's' }).data('powertiptarget', 'helpContent').on('powerTipRender', function() {
	    $('#powerTip').addClass('helpContent');
	});
	
	//tooltips for register-new
	$('[data-toggle="tooltip"]').tooltip({
		container: 'body',
		placement: function(context, source){
			var position = $(source).position();
	        if (screen.width >= 1100) {
	            return "right";
	        }
	        return "bottom";
		}
	});
	
	// check if input was auto-filled by browser
    setTimeout(function() {
       $.each($("input"), function ( ){
           if( $(this).val() != '' ){ $(this).addClass("not-empty") }
       });
    }, 500);
	
	$(".register-grid input, .login-grid input").on("change",function() {
		
		if ($(this).val() != ''){
			$(this).addClass("not-empty");
			if ( $(this).attr("id") == 'email' ){
				$("#email").addClass("not-empty");
			}
		}
		else $(this).removeClass("not-empty");
	});
	
	$("#email").on("keyup", function(e){
		if ( this.value != "") { $("#login").addClass("not-empty") }
		else { $(this).removeClass("not-empty") }
		
		if ($('#login').length) {
			document.getElementById("login").value = this.value.substr(0, this.value.indexOf('@') == -1 ? this.value.length : this.value.indexOf('@'));	
		}
	});
	
	
	$(".btn-forward").on("click", function(e){
		e.preventDefault();
		curr_el = $(this).closest("section").parent().find(".shown-step").eq(0);
		curr_el.add( curr_el.next() ).toggleClass("shown-step hidden");
		$(".btn-backward").show();
		if (curr_el.next().is(":last-child")){ $(".btn-forward").hide();}
		else {$(".btn-forward").show();}
	});
	
	$(".btn-backward").on("click", function(e){
		e.preventDefault();
		curr_el = $(this).closest("section").parent().find(".shown-step").eq(0);
		curr_el.add( curr_el.prev() ).toggleClass("shown-step hidden");
		if ( curr_el.prev().is(":first-child") ){ $(".btn-backward").hide();}
		else if(curr_el.prev().is(":last-child")) {$(".btn-forward").hide();}
		else {$(".btn-forward, .btn-backward").show();}
	});
	
	// track events via Google Analytics
    $('[data-action]').on('click', function() {
    	//console.log(" START ");
        var $this = $(this);
        hbdTrackEvent($this.data('category'), $this.data('action'), $this.data('label'), $this.data('value'));
    });
	
});


/**
 * jQuery Plugin: Character counter
 */
(function($, window, document, undefined) {
    var pluginName = 'counter',
        defaults = {  
    		message: '{chars} Zeichen übrig',
    		template: '<div class="counter"></div>'
        };
    
    function Plugin(element, options) {
        this.element = element;
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }
    
    Plugin.prototype = {
        init: function() {
        	var that = this,
        		$field = $(this.element),
        		$counter = $(this.options.template),
        		maxLength = parseInt($field.attr('maxlength'));
        	
        	if (maxLength === 0) { return; }
        		
    		$counter.insertAfter($field);
    		
    		$field.on('keyup', function() {
    			var	charLeft = maxLength - $field.val().length;
    			
    			$counter.text(that.options.message.replace('{chars}', charLeft));
    			
    			if (charLeft > 10) {
    				$counter.removeClass('counter-warn');
    			} else {
    				$counter.addClass('counter-warn');
    			}
    		}).trigger('keyup');
        }
    };

    // prevent against multiple instantiations
    $.fn[pluginName] = function (options) {
        return this.each(function() {
            if (!$.data(this, pluginName)) {
                $.data(this, pluginName, new Plugin(this, options));
            }
        });
    };    
})(jQuery, window, document);


/**
 * Accordion und Gallery(für Activity) Funktion für HUZ
 */

(function($) {

	/**
	 * Accordion Funktion für HUZ
	 */
 	$.fn.accordion = function(options) {
 		var opts = $.extend({}, $.fn.accordion.defaults, options ? options : false),
 			$acc = $(this),
 			$accHeads = $acc.find('.accordion-head');

 		if (opts.exclusive === true) {
 			// can be used later if all accordions parts need to be closed on flapout
 		}

 		// add arrow and show default selected content
 		$accHeads.each(function() {
 			var $head = $(this);

 			if ($head.hasClass('selected')) {
 				$head.next('.accordion-content').show();
 			}

 	 		$head.append('<span class="triangle"/>');
 		});

 		$acc.on('click', '.accordion-head', function(e) {
 			e.stopPropagation();

 			// do not flapout if links in head are clicked
 			if (e.target.nodeName === 'A') { return; }

 			var $head = $(this),
 				$content = $head.next('.accordion-content');

 			if ($content.is(':visible')) {
 	 			$head.removeClass('selected');
 				$content.slideUp();

 				$head.trigger('close.accordion');
 				$content.trigger('close.accordion');
 			} else {
 	 			$head.addClass('selected');
 	 			$content.slideDown();

 	 			$head.trigger('open.accordion');
 	 			$content.trigger('open.accordion');
 			}
 		});

		return this;
 	};

 	$.fn.accordion.defaults = {
 		'exclusive': false
 	};
 }(jQuery));

// keep it global after webpack processed it
 window.hbdTrackEvent = hbdTrackEvent;
 window.updateCompletionPie = updateCompletionPie;